<template>
  <transition-group tag="div" :name="slideDirection">
    <div
      v-for="(slide, index) in slides"
      v-show="index === currentIndex"
      :key="index"
      class="slide-item"
    >
      <img
        v-show="index === currentIndex && slide.type === 'img'"
        :src="slide.srcImage"
        alt="slider-image"
      />
      <video
        v-show="index === currentIndex && slide.type === 'video'"
        width="100%"
        height="100%"
        autoplay
        loop
        muted
      >
        <source :src="slide.srcWebm" type="video/webm" />
        <source :src="slide.srcMp4" type="video/mp4" />
        <p v-if="videoFallbackText">
          <a :href="src">{{ videoFallbackText }}</a>
        </p>
      </video>
    </div>
  </transition-group>
</template>

<script>
export default {
  name: 'PhoneContentTransitionGroup',
  props: {
    currentIndex: {
      type: Number,
      default: 0,
    },
    videoFallbackText: {
      type: String,
      default: null,
    },
    slides: {
      type: Array,
      required: true,
    },
  },
  data: () => ({
    slideDirection: 'slide-left',
  }),
  watch: {
    currentIndex: {
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          if (newValue > oldValue) {
            this.slideDirection = 'slide-right'
          } else {
            this.slideDirection = 'slide-left'
          }
        }
      },
    },
  },
}
</script>

<style lang="postcss">
.slide-item {
  width: 100%;
  height: 370px;

  img,
  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

@media (--sm) {
  .slide-item {
    width: 100%;
  }
}

@media (--md) {
  .slide-item {
    width: var(--dotcom-app__content-wrapper-width);
    height: var(--dotcom-app__content-wrapper-height);
  }
}

.slide-left-enter,
.slide-left-leave-to {
  opacity: 0;
  transform: translateX(-100%);
}

.slide-right-enter,
.slide-right-leave-to {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-leave,
.slide-left-enter-to {
  opacity: 1;
}

.slide-right-leave,
.slide-right-enter-to {
  opacity: 1;
}

.slide-left-enter-active,
.slide-right-enter-active {
  transition: all 0.75s cubic-bezier(0.19, 1, 0.22, 1);
}
</style>
